import { useEffect, useRef } from 'react';
import ReviewSection from './ReviewSection';

const cards = [
  { initials:'LU', bg:'linear-gradient(135deg,#FF5252,#C41200)', name:'Linda U.', loc:'Web Design', quote:'"The staff continually amaze me with their ability to transfer ones vision, talents into an exciting, compelling visual experience for the viewer. Additionally, their customer service is excellent!! I highly recommend this company."' },
  { initials:'KK', bg:'linear-gradient(135deg,#FB923C,#C2410C)', name:'Koni K.', loc:'Web Design', quote:'"Service has been great! They responded to my questions and concerns quickly. Eric has been able to communicate options for solutions and stay on budget. I highly recommend Koderspedia!"' },
  { initials:'CT', bg:'linear-gradient(135deg,#F87171,#991B1B)', name:'Chuck T.', loc:'Web Design', quote:'"Jay was very professional and delivered a very nice website for my business. It was a large task but it went well. The site includes thousands of products across multiple suppliers and he made it all happen in a few short months. We went from no site to one with API integration and POS ability. Great Work!!!!"' },
  { initials:'MS', bg:'linear-gradient(135deg,#FCA5A5,#B91C1C)', name:'Mike S.', loc:'Web Design', quote:'"If you want a reliable team that delivers quality work and maintains clear communication, choose Koderspedia. They listened to my needs, provided feedback, gave me creative suggestions, and delivered a final product that’s modern, smooth, and bug free. Definitely deserving of 5 stars!"' },
  { initials:'VM', bg:'linear-gradient(135deg,#FB7185,#BE123C)', name:'Van M.', loc:'Web Design', quote:'"It was really nice working with koderspedia, they have done my website project and marketing as well.I am very happy with my project manager Jay Brown. He address my concerns and resolve them ASAP."' },
  { initials:'KM', bg:'linear-gradient(135deg,#FB7185,#BE123C)', name:'Kenneth M.', loc:'Software Development', quote:'"Koderspedia really helped transform my idea from my imagination to a beautiful reality. I really look forward to working with them on my next project!"' },
];

export default function ThumbtackSection() {
  const trackRef = useRef(null);
  const progRef  = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const prog  = progRef.current;
    if (!track || !prog) return;

    const updateProg = () => {
      const max = track.scrollWidth - track.clientWidth;
      prog.style.width = (max > 0 ? (track.scrollLeft / max * 80 + 20) : 20) + '%';
    };
    track.addEventListener('scroll', updateProg, { passive: true });
    updateProg();

    let isDown=false, startX, startScroll, velX=0, lastX, lastT;
    const onDown = e => { isDown=true; track.classList.add('is-dragging'); startX=e.pageX; startScroll=track.scrollLeft; velX=0; lastX=e.pageX; lastT=Date.now(); e.preventDefault(); };
    const onMove = e => { if(!isDown) return; const now=Date.now(),dt=now-lastT||1; velX=(e.pageX-lastX)/dt; lastX=e.pageX; lastT=now; track.scrollLeft=startScroll-(e.pageX-startX); };
    const onUp = () => { if(!isDown) return; isDown=false; track.classList.remove('is-dragging'); let vel=velX*14; const mom=()=>{if(Math.abs(vel)<.5)return;track.scrollLeft-=vel;vel*=.91;requestAnimationFrame(mom);}; mom(); };
    track.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    let tStart, tStartScroll;
    track.addEventListener('touchstart', e=>{tStart=e.touches[0].clientX;tStartScroll=track.scrollLeft;},{passive:true});
    track.addEventListener('touchmove',  e=>{track.scrollLeft=tStartScroll-(e.touches[0].clientX-tStart);},{passive:true});

    return () => {
      track.removeEventListener('scroll', updateProg);
      track.removeEventListener('mousedown', onDown);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, []);

  return (
    <ReviewSection id="thumbtack">
      <div className="rs-label-row reveal-fade">
        <span className="rs-num">03</span>
        <span className="rs-platform-label">[ THUMBTACK REVIEWS ]</span>
        <span className="rs-score">4.9 / 5.0</span>
      </div>
      <div className="rs-giant-wrap">
        <div className="rs-giant reveal-clip" aria-hidden="true">THUMBTACK</div>
        <div className="rs-giant-meta reveal-fade">
          <div className="rs-stars-big" style={{color:'#C41200'}}>★★★★★</div>
          <div className="rs-count">120+ Local &amp; Global Reviews</div>
        </div>
        <h2 className="rs-heading reveal-fade">KodersPedia Reviews on Thumbtack</h2>
        <p className="rs-subheading reveal-fade">Local and global client experiences with the KodersPedia team</p>
      </div>

      <div className="yelp-scroll-wrap reveal-fade">
        <div className="yelp-scroll-track" id="yelpTrack" ref={trackRef}>
          {cards.map((c, i) => (
            <div key={i} className="yelp-card">
              <div className="yelp-card-stars">★★★★★</div>
              <div className="yelp-card-quote">{c.quote}</div>
              <div className="yelp-card-author">
                <div className="rs-av rs-av-sm" style={{background:c.bg, width:36, height:36, borderRadius:10, fontSize:11}}>{c.initials}</div>
                <div>
                  <div className="rs-name">{c.name}</div>
                  <div className="rs-role">{c.loc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="yelp-drag-bar-wrap">
          <div className="yelp-drag-label">
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none"><path d="M1 6h16M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Drag to explore all reviews
          </div>
          <div className="yelp-progress-track">
            <div className="yelp-progress-fill" id="yelpProgress" ref={progRef} />
          </div>
          <div style={{maxWidth:1300,margin:'40px auto 0',textAlign:'center'}}>
          <a href="https://www.thumbtack.com/ca/palo-alto/web-design/koderspedia-solutions-web-app-development/service/427573743556763651" target="_blank" rel="noopener noreferrer" style={{display:'inline-flex',alignItems:'center',gap:8,background:'#1b1f5e',border:'1px solid #1b1f5e6e)',color:'#fff',fontSize:13,fontWeight:600,padding:'12px 28px',borderRadius:100,textDecoration:'none',letterSpacing:'.03em'}}>
            Read All Reviews on Thumbtack →
          </a>
        </div>
        </div>
      </div>
    </ReviewSection>
  );
}
